import React from 'react';

const EventsIcon = ({
  width = '16',
  height = '16',
  fill = '#EF4821',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_620_27132)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.375 1.875C5.375 1.64294 5.28281 1.42038 5.11872 1.25628C4.95462 1.09219 4.73206 1 4.5 1C4.26794 1 4.04538 1.09219 3.88128 1.25628C3.71719 1.42038 3.625 1.64294 3.625 1.875V2.75H3.1C2.54305 2.75 2.0089 2.97125 1.61508 3.36508C1.22125 3.7589 1 4.29305 1 4.85L1 6.25H15V4.85C15 4.29305 14.7788 3.7589 14.3849 3.36508C13.9911 2.97125 13.457 2.75 12.9 2.75H12.375V1.875C12.375 1.64294 12.2828 1.42038 12.1187 1.25628C11.9546 1.09219 11.7321 1 11.5 1C11.2679 1 11.0454 1.09219 10.8813 1.25628C10.7172 1.42038 10.625 1.64294 10.625 1.875V2.75H5.375V1.875ZM15 7.65H1V12.9C1 13.457 1.22125 13.9911 1.61508 14.3849C2.0089 14.7788 2.54305 15 3.1 15H12.9C13.457 15 13.9911 14.7788 14.3849 14.3849C14.7788 13.9911 15 13.457 15 12.9V7.65Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_620_27132">
        <rect width="14" height="14" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

export default EventsIcon;
